/**
 * Build identity, injected at build time by vite.config.ts (`define`).
 * `appVersion` is the `version` field of package.json; shown on the login
 * screen so a stale pane (Office webview cache) can be spotted at a glance.
 */
export const appVersion: string = __APP_VERSION__
export const appBuildTime: string = __APP_BUILD_TIME__
